
export * from '../../frontend-js-dependencies-web/__liferay__/exports/uuid.js';
